export enum DrawingType {
  FOUNDATION = "FOUNDATION",
  STRUCTURE = "STRUCTURE",
  //WALL = "WALL"
  OTHER = "OTHER",
  VOID = "VOID",
}

export enum DrawingSize {
  INHERIT = "INHERIT",
}

export enum DrawingScale {
  NTS = "NTS",
  THREE_QUARTER_INCH = `3/4" = 1'`,
}

export enum DrawingScaleMode {
  UNIFORM = "UNIFORM",
  WIDTH_OVERRIDE = "WIDTH_OVERRIDE",
  HEIGHT_OVERRIDE = "HEIGHT_OVERRIDE",
  SCALE_TO_FIT = "SCALE_TO_FIT",
}
export enum DrawingId {
  NONE = "NONE",
  NULL = "NULL",
}
